class LocalStorageService {
  set(name: string, value: string | number | boolean | object): void {
    if (typeof value === 'object') {
      localStorage.setItem(name, JSON.stringify(value));
      return;
    }
    if (typeof value === 'boolean') {
      localStorage.setItem(name, value ? 'true' : 'false');
      return;
    }
    localStorage.setItem(name, `${value}`);
  }

  get(
    name: string,
    type?: 'string' | 'number' | 'boolean' | 'object',
  ): string | number | boolean | object | null {
    if (type === 'number') {
      return Number(localStorage.getItem(name));
    }
    if (type === 'boolean') {
      return localStorage.getItem(name) === 'true';
    }
    if (type === 'object') {
      return JSON.parse(`${localStorage.getItem(name)}`);
    }
    return localStorage.getItem(name);
  }

  remove(name: string): void {
    localStorage.removeItem(name);
  }
}

export const localStorageService = new LocalStorageService();
